module.exports = __webpack_public_path__ + "media/assets/google-classroom-svg-40a1e31d0a146b872d80cd9397eb7d17.svg";